<template>
	<!-- 编辑界面 -->
	<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" :wrapper-closable="false" :modal="false" :destroy-on-close="true" class="margin_top_40" @click="closeDialog">
		<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules">
			<el-form-item label="供应商名称" prop="name">
				<el-input clearable v-model="editForm.name" class="input_200px" size="small" auto-complete="off" placeholder="请输入供应商名称"></el-input>
			</el-form-item>
			<el-form-item label="联系人" prop="contactUser">
				<el-input clearable v-model="editForm.contactUser" class="input_200px" size="small" auto-complete="off" placeholder="请输入联系人"></el-input>
			</el-form-item>
			<el-form-item label="联系电话" prop="contactPhone">
				<el-input clearable v-model="editForm.contactPhone" class="input_200px" size="small" auto-complete="off" placeholder="请输入联系电话"></el-input>
			</el-form-item>
			<el-form-item label="地址" prop="address">
				<el-input clearable v-model="editForm.address" class="input_200px" size="small" auto-complete="off" placeholder="请输入地址"></el-input>
			</el-form-item>
		</el-form>
		<div class="drawer-footer">
			<el-button size="small" icon="el-icon-check" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
		</div>
	</el-drawer>
</template>

<script>
import { saveSupplyInfo, getSupplyInfoDetail } from "../../../api/baseDataApi.js";
export default {
	data() {
		return {
			title: "",
			loading: false, //是显示加载
			editFormVisible: false, //控制编辑页面显示与隐藏
			editForm: {
				keyId: "",
				name: "",
				contactUser: "",
				contactPhone: "",
				address: ""
			},
			// rules 表单验证
			rules: {
				name: [
					{
						required: true,
						message: "请输入供应商名称",
						trigger: "blur"
					}
				],
				contactUser: [
					{
						required: true,
						message: "请输入联系人",
						trigger: "blur"
					}
				],
				contactPhone: [
					{
						required: true,
						message: "请输入联系电话",
						trigger: "blur"
					},
					{
						pattern: /^1[3456789]\d{9}$/,
						message: "请输入正确的手机号",
						trigger: "blur"
					}
				],
				address: [
					{
						required: true,
						message: "请输入地址",
						trigger: "blur"
					}
				]
			}
		};
	},
	computed: {},
	watch: {},

	methods: {
		//显示编辑界面
		editShow(row) {
			if (row != undefined && row != "undefined") {
				this.title = "编辑";
				let parmer = {
					keyId: row.keyId
				};
				getSupplyInfoDetail(parmer)
					.then((res) => {
						if (res.code == 1) {
							this.editForm = res.data;
							this.editFormVisible = true;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("供应商信息获取失败!");
					});
			} else {
				this.title = "新增";
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.editFormVisible = true;
			}
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					saveSupplyInfo(this.editForm)
						.then((res) => {
							this.editFormVisible = false;
							this.loading = false;
							if (res.code == 1) {
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "供应商保存成功！"
								});
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.editFormVisible = false;
							this.loading = false;
							this.$message.error("供应商保存失败，请稍后再试！");
						});
				} else {
					return false;
				}
			});
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editFormVisible = false;
			this.$data.editForm = this.$options.data.call(this).editForm;
		}
	},
	created() {},
	mounted() {},
	components: {}
};
</script>
<style scoped>
.wip {
	width: 200px !important;
}
</style>
